/**
 * Atributos de `<img>` para uma imagem pública do marketplace (produto/bundle).
 *
 * Aponta para a variante WebP redimensionada gerada no upload
 * (ProductImageVariants no backend: `opt/<nome>.<sm|lg>.webp`) e, se ela não
 * existir, o `onerror` troca uma única vez pelo arquivo original. O Mithril não
 * reescreve o `src` depois porque o atributo do vnode não muda entre redraws.
 *
 * - `sm`: até 320px de largura (cards, miniaturas, ícone do hero).
 * - `lg`: até 1600px (capa/banner grande).
 */
const VARIANT_SOURCE = /^([A-Za-z0-9_-][A-Za-z0-9._-]{0,179})\.(png|jpe?g|webp)$/i;
export function mpImageUrl(file) {
  return `/assets/marketplace/${file}`;
}
export function mpImage(file, size) {
  if (size === void 0) {
    size = 'sm';
  }
  const original = mpImageUrl(file);
  const match = VARIANT_SOURCE.exec(file);
  if (!match || file.includes('..')) return {
    src: original
  };
  return {
    src: `/assets/marketplace/opt/${match[1]}.${size}.webp`,
    onerror: e => {
      e.redraw = false;
      const img = e.currentTarget;
      if (!img.src.endsWith(original)) img.src = original;
    }
  };
}
flarum.reg.add('ramon-marketplace', 'common/utils/mpImage', { mpImageUrl: mpImageUrl,mpImage: mpImage, });